import { AntdGrid } from "@murm/ant";

const { useBreakpoint } = AntdGrid;

/** True below 1200px (antd's `xl`), where pages stack their columns. */
export const useIsStacked = () => !useBreakpoint().xl;
